/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuIcon } from '@neutron/react';

export const CardContainer = styled.div`
  display: flex;
  padding: 0.5rem 0;
  position: relative;
`;

export const CardHeaderContainer = styled.div`
  position: absolute;
  top: 0.4em;
  right: 0.5em;
`;

export const CardHeader = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #124e7f;
`;

export const CardContentMetaDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-right: 0.65rem;
`;

export const CardContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 100%;
`;
export const CardContent = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
`;

export const CardContentBold = styled(CardContent)`
  font-weight: bold;
`;

export const ChevronRightIcon = styled(NeuIcon)`
  position: absolute;
  color: #124e7f;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  margin-left: auto;
  right: -12px;
  top: 40%;
`;

export const CoachingOppsContainer = styled.ul`
  max-width: 12em;
  padding: 0;
  margin: 0;
`;

export const CoachingOppLabel = styled.li`
  font-size: 0.9rem !important;
  left: 1em;
  position: relative;
  word-break: break-word;
`;
